import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const SystemTypeSurvey = () => {
  return (
    <SettingsMetaData propertyName={"System_Type_Survey"} viewPropertyName={"System Type"} />
  );
};
export default SystemTypeSurvey;